import React from 'react';
import styled from 'styled-components';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

// Styled Tabs
const StyledTabs = styled(Tabs)`
  & .MuiTabs-indicator {
    background-color: ${(props) => props.indicatorColor || 'blue'};
  }
  .MuiTabs-flexContainer {
    display: flex !important;
    justify-content: space-between !important;
  }
`;

// Styled Tab
const StyledTab = styled(Tab)`
  font-size: ${(props) => props.fontSize || '1rem'} !important;
  color: ${(props) => props.color || 'black'} !important;
  font-family: 'Akkuart_Bold' !important;
  background-color: ${(props) => props.bgcolor || 'transparent'} !important;
  &.Mui-selected {
    color: ${(props) => props.selectedColor || 'blue'} !important;
    font-family: 'Akkuart_Bold';
  }
`;

const CustomTabs = ({
  tabs,
  value,
  tabData,
  onChange,
  tabStyles,
  indicatorColor,
}) => {
  const handleChange = (event, newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  const getTabBackgroundColor = (tabValue) => {
    const data = tabData?.find((item) => item.label === tabValue);
    if (data?.isHoliday) {
      return '#FF8A8A';
    }
    if (data?.isShow && !data?.holiday) {
      return '#C8E6C9';
    }
    return 'transparent';
  };

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
        indicatorColor={indicatorColor}
      >
        {tabs?.length > 0 &&
          tabs.map((tab) => (
            <StyledTab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              bgcolor={getTabBackgroundColor(tab.label)}
              {...tabStyles}
              wrapped
            />
          ))}
      </StyledTabs>
    </Box>
  );
};

export default CustomTabs;
